import './home.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import teksturtitle from './assets/home/teksturtitle.png'

import teksturlogo from './assets/home/tekstur1337.png'

import wwwappstore15pct from './assets/home/wwwappstore15pct.png'
import wwwgoogleplay15pct from './assets/home/wwwgoogleplay15pct.png'
import privacybutton from './assets/home/privacybutton.png'
import supportbutton from './assets/home/supportbutton.png'
import Footer from './footer'

import workinprogress from './assets/home/workinprogress2.png'

function TekstUr() {
  return (
    <div className="page">
      <div className="main_page">
        <a href="/">
          <img className="woohooologo" src={wwwwoohooo} />
        </a>
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex' }}>
        <div className="tekstur" style={{ flex: 1, marginTop: '1vw' }}>
          <img className="teksturtitle2" src={teksturtitle} />
          <div className="rankytanksubtitle">..danish app, that could teach kids on how the tell the clock.</div>
          <img className="rankytanklogo" src={teksturlogo} />
          <div>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <div className="rankytankapplestore">
                <a href="https://apps.apple.com/dk/app/tekstur/id6758062123">
                  <img src={wwwappstore15pct} />
                </a>
              </div>
              <div className="rankytankgoogleplay">
                <a href="https://play.google.com/store/apps/details?id=com.tekstur">
                  <img src={wwwgoogleplay15pct} />
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ display: 'flex', gap: 5, flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div style={{}}>
                    <a href="/teksturprivacy">
                      <img src={privacybutton} />
                    </a>
                  </div>
                  <div style={{}}>
                    <a href="/tekstursupport">
                      <img src={supportbutton} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default TekstUr
